import React from 'react';
import './Ebblowapplicat.css';
import Ebblow1 from '../../../imgs/Ebblow1.webp'; 
import Ebblow2 from '../../../imgs/Ebblow2.webp';

const Ebblowapplicat = () => {
  return (
    <div className="ebblow-container">
      <h1> Applications</h1>
      <div className="card-wrapper">
        <div className="ebblows-card">
          <img src={Ebblow1} alt="Application1" />
        </div>

        <div className="ebblows-card">
          <img src={Ebblow2} alt="Application 2" />
        
        </div>
      </div>
    </div>
  );
};

export default Ebblowapplicat;
